<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }" class="tsny_form">
    <b-container>
      <b-row>
        <b-col></b-col>
        <b-col>
          <logo-full />
          <b-form v-if="showRegistrationForm" class="tsny_form">
            <b-row>
              <b-col
                ><b-text-input-validated
                  type="text"
                  v-model="first"
                  rules="required"
                  label="First"
                />
              </b-col>
              <b-col>
                <b-text-input-validated
                  type="text"
                  v-model="last"
                  rules="required"
                  label="Last"
              /></b-col>
            </b-row>
            <b-row>
              <b-col>
                <BTextInputValidated
                  :rules="{
                    required: true,
                    min: 8,
                    regex: passwordRegex
                  }"
                  type="password"
                  label="Password"
                  name="confirm"
                  v-model="password"
                >
                  <div class="password_validators">
                    <b-row>
                      <b-col>
                        <span
                          class="tsny_field_error-text"
                          :class="[
                            lengthError ? 'text-danger' : 'text-success'
                          ]"
                        >
                          Password is at least 8 characters long
                        </span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <span
                          class="tsny_field_error-text"
                          :class="[regexError ? 'text-danger' : 'text-success']"
                        >
                          Contains at least one capital, lowercase, and number
                        </span>
                      </b-col>
                    </b-row>
                  </div>
                </BTextInputValidated>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <BTextInputValidated
                  rules="password:confirm"
                  type="password"
                  label="Confirm Password"
                  v-model="confirmPassword"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-text-input-validated
                  type="tel"
                  v-model="phone"
                  :rules="{ required: true, length: 12 }"
                  v-mask="'###-###-####'"
                  label="Phone Number"
                >
                  <template v-slot="errorSlot">
                    <p class="tsny_field_error-text">
                      {{ phoneErrorText(errorSlot.errors) }}
                    </p>
                  </template>
                </b-text-input-validated>
              </b-col>
              <b-col>
                <b-text-input-validated
                  type="date"
                  v-model="dob"
                  :rules="{ required: true }"
                  label="Date of Birth"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="8"
                ><b-text-input-validated
                  type="text"
                  v-model="street"
                  rules="required"
                  label="Street"
                />
              </b-col>
              <b-col>
                <b-text-input-validated
                  type="text"
                  v-model="unit"
                  label="Unit"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6"
                ><b-text-input-validated
                  type="text"
                  v-model="city"
                  rules="required"
                  label="City"
                />
              </b-col>
              <b-col>
                <b-text-input-validated
                  type="text"
                  v-model="state"
                  rules="required"
                  label="State"
              /></b-col>
              <b-col>
                <b-text-input-validated
                  type="text"
                  v-model="zip"
                  :rules="{ required: true, length: 5, numeric: true }"
                  v-mask="'#####'"
                  label="ZIP"
                >
                  <template v-slot="errorSlot">
                    <p class="tsny_field_error-text">
                      {{ zipErrorText(errorSlot.errors) }}
                    </p>
                  </template>
                </b-text-input-validated></b-col
              >
            </b-row>
            <b-row align-h="center">
              <b-button
                class="tsny_button"
                :disabled="invalid"
                @click="register()"
                >CREATE ACCOUNT</b-button
              >
              <p v-if="registerError" class="tsny_status-text">
                There was an error creating your account. Please try again in a
                few minutes
              </p>
            </b-row>
          </b-form>
          <b-form v-if="registerSuccess" class="tsny_form">
            <b-row align-h="center">
              <p class="tsny_status-text">
                An account has been successfully registered with the email
                {{ email }}
              </p>
              <b-button class="tsny_button" @click="toLogin"
                >RETURN TO SIGN IN</b-button
              >
            </b-row>
          </b-form>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </ValidationObserver>
</template>

<script>
import ExternalRestService from "../../services/rest/services/ExternalRestService";
import StoreConstants from "../../store/services/StoreConstants";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../../components/FormInputs/BTextInputValidated";

export default {
  name: "Registration",
  components: {
    ValidationObserver,
    BTextInputValidated
  },
  props: {
    token: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      first: null,
      last: null,
      phone: null,
      dob: null,
      password: null,
      confirmPassword: null,
      street: null,
      unit: null,
      city: null,
      state: null,
      zip: null,
      showRegistrationForm: true,
      registerSuccess: false,
      registerError: false,
      passwordRegex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    };
  },
  computed: {
    ...mapGetters({ email: StoreConstants.GETTERS.USER }),
    lengthError: function() {
      return !this.password || this.password.length < 8;
    },
    regexError: function() {
      return !this.password || !this.passwordRegex.test(this.password);
    }
  },
  mounted: function() {
    this.vuexSetToken(this.token);
  },
  methods: {
    ...mapActions({ vuexSetToken: StoreConstants.ACTIONS.SET_TOKEN }),
    phoneErrorText: function(errors) {
      return errors[0] && errors[0] !== "Required"
        ? '"###-###-####"'
        : errors[0];
    },
    zipErrorText: function(errors) {
      return errors[0] && errors[0] !== "Required" ? '"#####"' : errors[0];
    },
    register: async function() {
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.registerError = false;
      return ExternalRestService.createAccount({
        email: $comp.email,
        password: $comp.password,
        first: $comp.first,
        last: $comp.last,
        phone: $comp.phone,
        dob: $comp.dob,
        address: {
          street: $comp.street,
          unit: $comp.unit,
          city: $comp.city,
          state: $comp.state,
          zip: $comp.zip
        }
      })
        .then(() => {
          $comp.showRegistrationForm = false;
          $comp.registerSuccess = true;
        })
        .catch(error => {
          console.log(error);
          $comp.registerError = true;
        });
    },
    toLogin: function() {
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style scoped>
.password_validators {
  margin-bottom: 25px;
}
</style>
